import './HourglassLoader.less';
import { Icon } from 'components/atoms/Icon.tsx';

export type Props = {
	duration?: number;
	size?: number;
	color?: string; // The filler and border color
	showSandFlow?: boolean;
};

export function HourglassLoader({ duration = 2, size = 40, showSandFlow, color = '#bfc3c8' }: Props) {
	return (
		<div
			data-test="hourglass-loader"
			class="hourglass-loader relative"
			style={{
				height: size,
				width: size,
				'--hourglass-loader-duration': `${duration}s`,
				'--hourglass-loader-color': color,
			}}
		>
			<div class="absolute overflow-hidden flex bottom-0 top-0 items-end">
				<Icon size={size} type="hourglass" className="" />
			</div>
			<div class="hourglass-loader__first absolute overflow-hidden flex bottom-0 top-0 items-end">
				<Icon size={size} type="hourglass_top" className="" />
			</div>
			<div class="hourglass-loader__second absolute overflow-hidden flex bottom-0 top-0 items-end">
				<Icon size={size} type="hourglass_bottom" className="" />
			</div>
			{showSandFlow && <div class="hourglass-loader__sand"></div>}
		</div>
	);
}
